<template>
  <option-distribution-chart
    :campo="campo"
    :label="label"
    :rows="rows"
    color="#26a69a"
  />
</template>

<script>
import OptionDistributionChart from '@/components/client/rounds/nps-dashboard/components/OptionDistributionChart.vue';

export default {
  name: 'NpsReplicaRadioChart',
  components: {
    OptionDistributionChart
  },
  props: {
    campo: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    rows: {
      type: Array,
      default: function () {
        return [];
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/nps-dashboard/components/RadioChart.vue